/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import SectionTitle from "./SectionTitle";
import { cn } from "../../../../utils/classnames";

const CustomerInformation = ({
    isMultipleVehicle,
    vehiclePassengerRows,
    passengerNameText,
    passengerPhoneText,
    booking
}) => {
    return (
        <>
            <SectionTitle title="Customer Information" />
            <div className="border rounded mb-5">
                <div className="d-flex align-items-start gap-5 p-3">
                    <div className="flex-shrink-0" style={{ width: "120px" }}>
                        <div className="tw:!font-hanken-grotesk tw:!text-[15px] tw:!font-[700] tw:!text-[#4E4E4E]">
                            <div>Passenger</div>
                            <div>Information</div>
                        </div>
                    </div>
                    <div className="tw:flex-1 tw:flex tw:flex-col">
                        {isMultipleVehicle ? (
                            vehiclePassengerRows.map((row, index) => (
                                <div key={row.key} className={cn(index > 0 && "tw:pt-6", index < vehiclePassengerRows.length - 1 && "tw:pb-6")}>
                                    <div className="tw:grid tw:grid-cols-1 tw:gap-4 tw:md:grid-cols-[340px_1px_1fr_1fr] tw:md:items-center">
                                        <div>
                                            <div className="tw:!font-hanken-grotesk tw:!m-0 tw:!text-[13px] tw:!font-[400] tw:!text-[#8D8D8D]">{row.vehicleLabel}</div>
                                            <div className="tw:!font-hanken-grotesk tw:!text-[15px] tw:!font-[400] tw:!text-[#282828]">{row.vehicleName}</div>
                                        </div>
                                        <div className="tw:hidden tw:md:block tw:h-full tw:w-px tw:bg-[#E8E8E8]" />
                                        <div>
                                            <div className="tw:!font-hanken-grotesk tw:!m-0 tw:!text-[13px] tw:!font-[400] tw:!text-[#8D8D8D]">Passenger's Name</div>
                                            <div className="tw:!font-hanken-grotesk tw:!text-[15px] tw:!font-[400] tw:!text-[#282828]">
                                                {passengerNameText}
                                            </div>
                                        </div>
                                        <div>
                                            <div className="tw:!font-hanken-grotesk tw:!m-0 tw:!text-[13px] tw:!font-[400] tw:!text-[#8D8D8D]">Phone Number</div>
                                            <div className="tw:!font-hanken-grotesk tw:!text-[15px] tw:!font-[400] tw:!text-[#282828]">
                                                {passengerPhoneText}
                                            </div>
                                        </div>
                                    </div>
                                    {index < vehiclePassengerRows.length - 1 ? <div className="tw:mt-6 tw:h-px tw:w-full tw:bg-[#E8E8E8]" /> : null}
                                </div>
                            ))
                        ) : (
                            <div className="d-flex flex-wrap" style={{ columnGap: "3rem", rowGap: "0.75rem" }}>
                                <div>
                                    <div className="tw:!font-hanken-grotesk tw:!m-0 tw:!text-[13px] tw:!font-[400] tw:!text-[#8D8D8D]">Passenger's Name</div>
                                    <div className="tw:!font-hanken-grotesk tw:!text-[15px] tw:!font-[400] tw:!text-[#282828]">
                                        {passengerNameText}
                                    </div>
                                </div>
                                <div>
                                    <div className="tw:!font-hanken-grotesk tw:!m-0 tw:!text-[13px] tw:!font-[400] tw:!text-[#8D8D8D]">Phone Number</div>
                                    <div className="tw:!font-hanken-grotesk tw:!text-[15px] tw:!font-[400] tw:!text-[#282828]">
                                        {passengerPhoneText}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                <hr className="hr-E8E8E8 m-0" />
                <div className="d-flex align-items-start gap-5 p-3">
                    <div className="flex-shrink-0" style={{ width: "120px" }}>
                        <div className="tw:!font-hanken-grotesk tw:!text-[15px] tw:!font-[700] tw:!text-[#4E4E4E]">
                            <div>Billing</div>
                            <div>Information</div>
                        </div>
                    </div>
                    <div className="tw:flex-1 tw:flex tw:flex-col tw:gap-6">
                        <div className="tw:grid tw:grid-cols-1 tw:gap-3 tw:md:grid-cols-4 tw:md:gap-8">
                            <div>
                                <div className="tw:!font-hanken-grotesk tw:!m-0 tw:!text-[13px] tw:!font-[400] tw:!text-[#8D8D8D]">Reservation Holder</div>
                                <div className="tw:!font-hanken-grotesk tw:!text-[15px] tw:!font-[400] tw:!text-[#282828]">
                                    {`${booking?.customer?.pronounced || ""} ${booking?.customer?.name || "-"}`.trim()}
                                </div>
                            </div>
                            <div>
                                <div className="tw:!font-hanken-grotesk tw:!m-0 tw:!text-[13px] tw:!font-[400] tw:!text-[#8D8D8D]">Email</div>
                                <div className="tw:!font-hanken-grotesk tw:!text-[15px] tw:!font-[400] tw:!text-[#282828]">{booking?.customer?.email || "-"}</div>
                            </div>
                            <div>
                                <div className="tw:!font-hanken-grotesk tw:!m-0 tw:!text-[13px] tw:!font-[400] tw:!text-[#8D8D8D]">Phone Number</div>
                                <div className="tw:!font-hanken-grotesk tw:!text-[15px] tw:!font-[400] tw:!text-[#282828]">
                                    {booking?.customer?.prefix_number && booking?.customer?.phone
                                        ? `(${booking?.customer?.prefix_number}) ${booking?.customer?.phone}`
                                        : "-"}
                                </div>
                            </div>
                            <div>
                                <div className="tw:!font-hanken-grotesk tw:!m-0 tw:!text-[13px] tw:!font-[400] tw:!text-[#8D8D8D]">Country</div>
                                <div className="tw:!font-hanken-grotesk tw:!text-[15px] tw:!font-[400] tw:!text-[#282828]">{booking?.customer?.country || "-"}</div>
                            </div>
                        </div>

                        <div className="tw:grid tw:grid-cols-1 tw:gap-3 tw:md:grid-cols-4 tw:md:gap-8">
                            <div>
                                <div className="tw:!font-hanken-grotesk tw:!m-0 tw:!text-[13px] tw:!font-[400] tw:!text-[#8D8D8D]">Postal Code</div>
                                <div className="tw:!font-hanken-grotesk tw:!text-[15px] tw:!font-[400] tw:!text-[#282828]">{booking?.customer?.postal_code || "-"}</div>
                            </div>
                            <div>
                                <div className="tw:!font-hanken-grotesk tw:!m-0 tw:!text-[13px] tw:!font-[400] tw:!text-[#8D8D8D]">City</div>
                                <div className="tw:!font-hanken-grotesk tw:!text-[15px] tw:!font-[400] tw:!text-[#282828]">{booking?.customer?.city || "-"}</div>
                            </div>
                            <div className="tw:md:col-span-2">
                                <div className="tw:!font-hanken-grotesk tw:!m-0 tw:!text-[13px] tw:!font-[400] tw:!text-[#8D8D8D]">Billing Address</div>
                                <div className="tw:!font-hanken-grotesk tw:!text-[15px] tw:!font-[400] tw:!text-[#282828]">{booking?.customer?.address || "-"}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CustomerInformation;
